module.exports = __webpack_public_path__ + "img/hj1.709aa9d0.jpg";